import { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import WhyDifferentUnified from './components/WhyDifferentUnified';
import CoreFeatures from './components/CoreFeatures';
import ImageGallery from './components/ImageGallery';
import EmailSignup from './components/EmailSignup';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      <Header />
      <HeroSection />
      <CoreFeatures />
      <WhyDifferentUnified />
      <ImageGallery />
      <EmailSignup />
      <FAQ />
      <Footer />
    </div>
  );
}
